import { render, staticRenderFns } from "./PaymentSepaModal.vue?vue&type=template&id=2b30807b&scoped=true"
import script from "./PaymentSepaModal.vue?vue&type=script&lang=js"
export * from "./PaymentSepaModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentSepaModal.vue?vue&type=style&index=0&id=2b30807b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b30807b",
  null
  
)

export default component.exports